import { useTranslation } from 'react-i18next'
import NavDropdown from '@/components/layout/NavDropdown'
import './index.less'

interface LanguageOption {
  value: string
  shortLabel: string
  label: string
}

const LANGUAGE_OPTIONS: LanguageOption[] = [
  { value: 'en', shortLabel: 'EN', label: 'English' },
  { value: 'zh', shortLabel: 'CN', label: '中文' },
]

interface LanguageSwitcherProps {
  compact?: boolean
  onChanged?: () => void
  align?: 'left' | 'right'
}

const DEFAULT_LANGUAGE = LANGUAGE_OPTIONS[0].value

const getLanguageBase = (language?: string) => language?.split('-')[0]

const resolveLanguage = (language?: string) => {
  const exactMatch = LANGUAGE_OPTIONS.find(item => item.value === language)
  if (exactMatch) return exactMatch.value

  const languageBase = getLanguageBase(language)
  const baseMatch = LANGUAGE_OPTIONS.find(
    item => getLanguageBase(item.value) === languageBase
  )

  return baseMatch?.value || DEFAULT_LANGUAGE
}

const LanguageSwitcher = ({
  compact = false,
  onChanged,
  align = 'right',
}: LanguageSwitcherProps) => {
  const { i18n } = useTranslation()
  const currentLang = resolveLanguage(i18n.language)
  const currentOption =
    LANGUAGE_OPTIONS.find(item => item.value === currentLang) ||
    LANGUAGE_OPTIONS[0]

  const handleSelect = (item: { value?: string }) => {
    if (!item.value) return
    i18n.changeLanguage(item.value)
    document.documentElement.lang = item.value
    onChanged?.()
  }

  return (
    <div className="lang-switcher">
      <NavDropdown
        label={currentOption.shortLabel}
        items={LANGUAGE_OPTIONS}
        selectedValue={currentLang}
        onSelect={handleSelect}
        align={align}
        compact={compact}
        openOnHover={!compact}
        menuTheme="gray"
      />
    </div>
  )
}

export default LanguageSwitcher
